module.exports = __webpack_public_path__ + "static/media/hg_logo-color.a6dcba37.svg";